import type { DocMigration } from "../docMigration";

const OVERRIDABLE_CATEGORIES_MINUS_TAGS = [
  "ANNOT_DETAIL",
  "ANNOT_LINEWORK",
  "ANNOT_NOTE",
  "ANNOT_DIM_LABEL",
  "ANNOT_DIM_LINEWORK",
  "ANNOT_DIM_TICK",
  "ANNOT_DIM_WITNESS",
  "SECTION_VIEW_CALLOUT",
  "CEILING",
  "PROP_APPLIANCES",
  "PROP_FIXTURES",
  "PROP_FURNITURE",
  "PROP_OTHER",
  "PROP_TAG",
];

function hasActiveTrueLabels(labels: Record<string, boolean> | undefined): boolean {
  if (!labels) {
    return false;
  }
  return Object.values(labels).some(Boolean);
}

const migration: DocMigration = {
  id: "20260622_add_vto_labels_to_tag_annotations",
  description: "Modify VTO visibility effect categories so room tags remain visible",
  apply(json: any) {
    const viewTemplateOverrides = json.viewTemplateOverrides ?? {};
    const effects = json.effects ?? {};

    for (const vtoId in viewTemplateOverrides) {
      const vto = viewTemplateOverrides[vtoId];
      if (vto.selectionMethod !== "BY_LABEL") {
        continue;
      }
      if (!hasActiveTrueLabels(vto.labels)) {
        continue;
      }

      for (const effectId in effects) {
        const effect = effects[effectId];
        if (effect.parentId !== vtoId) {
          continue;
        }
        if (effect.type !== "VISIBILITY") {
          continue;
        }
        const effectCategories: string[] = effect.categories ?? [];
        if (effectCategories.length === 0) {
          effects[effectId] = {
            ...effect,
            categories: [...OVERRIDABLE_CATEGORIES_MINUS_TAGS],
          };
        }
      }
    }

    return json;
  },
};

export default migration;
